<p>Please include the following log ID in the support ticket:</p>
<div class="log-id-box">
  <span class="log-id">{{ logId }}</span>
  <button
    mat-icon-button
    #tooltip="matTooltip"
    matTooltip="Copied"
    matTooltipPosition="above"
    [matTooltipDisabled]="true"
    (click)="copyAndShowTooltip()"
  >
    <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
  </button>
</div>
